// import { Link } from "gatsby"
import React from "react"

export default function Header({heading, subHeading}) {
  return (
    <div className="banner">
      <div className="banner-text">
          <h1>{heading}</h1>
          <h3>{subHeading}</h3>
      {/* <svg className= "wave" height="100%" width="100%" id="svg" viewBox="0 0 1440 600" xmlns="http://www.w3.org/2000/svg" class="transition duration-300 ease-in-out delay-150"><path d="M 0,600 C 0,600 0,300 0,300 C 187.19999999999993,266.26666666666665 374.39999999999986,232.53333333333336 531,249 C 687.6000000000001,265.46666666666664 813.6000000000001,332.1333333333333 960,349 C 1106.3999999999999,365.8666666666667 1273.1999999999998,332.93333333333334 1440,300 C 1440,300 1440,600 1440,600 Z" stroke="none" stroke-width="0" fill="#bae6ffff" class="transition-all duration-300 ease-in-out delay-150" transform="rotate(-180 720 300)"></path></svg> */}
      </div>
    </div>
  )
}